import { useEffect, useState } from 'react'
import { sendEmailVerification } from '~/lib/api'
import { useTranslation } from 'react-i18next'
import { Modal, FormContent, FormHeader, ButtonDrawer } from '~/components'
import * as styles from './index.module.css'

const RESEND_COOLDOWN = 30

export default function EmailVerificationModal({ email, userId, onClose }) {
  const { t } = useTranslation()
  const [countdown, setCountdown] = useState(RESEND_COOLDOWN)
  const [isResending, setIsResending] = useState(false)

  useEffect(() => {
    if (countdown <= 0) return
    const id = setTimeout(() => setCountdown(c => c - 1), 1000)
    return () => clearTimeout(id)
  }, [countdown])

  const handleResend = () => {
    setIsResending(true)
    sendEmailVerification(userId, email)
      .then(() => setCountdown(RESEND_COOLDOWN))
      .catch(() => {})
      .finally(() => setIsResending(false))
  }

  const buttons = [
    {
      func: handleResend,
      title: countdown > 0
        ? t('email-verify-resend-countdown', { seconds: countdown })
        : t('email-verify-resend'),
      disabled: countdown > 0 || isResending,
      isLoading: isResending,
    },
    { func: onClose, title: t('button-close') },
  ]

  return (
    <Modal isOpen rounded>
      <FormContent>
        <FormHeader>{t('email-verify-sent-title')}</FormHeader>
        <p className={styles.body}>
          {t('email-verify-sent-body')} <strong>{email}</strong>
        </p>
      </FormContent>
      <ButtonDrawer buttons={buttons} isLoading={isResending} modal />
    </Modal>
  )
}
